var map = {
	"./013---ExplosiveGrenade.json": 64492,
	"./014---FastGrenade.json": 42970,
	"./015---ClusterBomb.json": 82808,
	"./016---MagnetGrenade.json": 80564,
	"./017---StunningGrenade.json": 2291,
	"./018---IceBomb.json": 5844,
	"./019---FireBomb.json": 27542,
	"./020---RootBomb.json": 26795,
	"./021---OilBomb.json": 14764,
	"./022---SideBomb.json": 30805,
	"./023---Pokebomb.json": 10896,
	"./024---HolyWater.json": 18708
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 78290;